import {JsonConfigInterface} from './json-config-interface';
import {Utils} from '@astek/utils';

export type LivePressureStepSizeConfigJson = {
  maxNumberOfLabels: number;
  stepSizeRange: Array<number>;
  lineRatio: number;
};

export class LivePressureStepSizeConfig implements JsonConfigInterface<LivePressureStepSizeConfigJson> {
  private _maxNumberOfLabels: number = 0;
  private _stepSizeRange: Array<number> = [];
  private _lineRatio: number = 1;

  constructor(json?: LivePressureStepSizeConfigJson) {
    if (!Utils.isNullOrUndefined(json)) {
      this.deserializeJson(json);
    }
  }

  public get maxNumberOfLabels(): number {
    return this._maxNumberOfLabels;
  }

  public get stepSizeRange(): Array<number> {
    return this._stepSizeRange;
  }

  public get lineRatio(): number {
    return this._lineRatio;
  }

  public deserializeJson(json: LivePressureStepSizeConfigJson): void {
    this._maxNumberOfLabels = json.maxNumberOfLabels;
    this._stepSizeRange = json.stepSizeRange;
    this._lineRatio = json.lineRatio;
  }

}
